export default __webpack_public_path__ + "static/media/mhub_logo_desktop.3bc36aa5.svg";